import { Card, CardContent } from '../ui/card';

const StatCard = ({ value, label, colorClass = '', borderClass = 'border-primary', testId }) => (
  <Card className={`border-2 ${borderClass} cream-bg`}>
    <CardContent className="pt-6 text-center">
      <div className={`text-4xl font-bold mb-2 ${colorClass || 'blue-text'}`} data-testid={testId}>{value}</div>
      <div className={`text-sm font-sans ${colorClass || 'blue-text opacity-80'}`}>{label}</div>
    </CardContent>
  </Card>
);

export const RSVPStats = ({ stats }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
    <StatCard value={stats.total} label="Total RSVPs" testId="stat-total-rsvps" />
    <StatCard value={stats.attending} label="Attending" colorClass="text-green-600" borderClass="border-green-500" testId="stat-attending" />
    <StatCard value={stats.declining} label="Declining" colorClass="text-red-600" borderClass="border-red-500" testId="stat-declining" />
    <StatCard value={stats.day1} label="Sept 6" testId="stat-day1" />
    <StatCard value={stats.day2} label="Sept 7" testId="stat-day2" />
    <StatCard value={stats.day3} label="Sept 8" testId="stat-day3" />
  </div>
);
